// Central site configuration — update contact details here, never inside pages.
export const SITE = {
  name: "Nursing Home in Penang",
  domain: "nursinghomeinpenang.com",
  url: "https://nursinghomeinpenang.com",
  // Official WhatsApp number in international format (no +, spaces or hyphens).
  whatsappNumber: "60126678801",
  whatsappDisplay: "+60 12-667 8801",
  // Call Advisory Hotline: WhatsApp voice call to the official number.
  callHotlineNumber: "+60126678801",
  callHotlineUrl: "https://call.whatsapp.com/voice/60126678801",
  company: {
    name: "Mii Global Partner Holdings Sdn Bhd",
    registration: "202601028203 / 1690298-K",
    address: "57-30-06, Mansion One, Jalan Sultan Ahmad Shah, 10050, Penang, Malaysia",
  },
};

export const WA_MESSAGES = {
  homepage:
    "Hi, I found nursinghomeinpenang.com and would like help finding a suitable nursing home in Penang. Please assist me with the available options.",
  freeAssistance:
    "Hi, I found nursinghomeinpenang.com and would like free assistance finding a suitable nursing home in Penang.",
  referral: (facilityName) =>
    `Hi, I found ${facilityName} on nursinghomeinpenang.com and would like the directory to assist me with a referral enquiry for this facility.`,
  listFacility:
    "Hi, I represent a nursing home or elderly care facility in Penang and would like to submit our details for verification and listing on nursinghomeinpenang.com.",
};

export const waLink = (message = WA_MESSAGES.homepage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const buildEnquiryMessage = ({ name, phone, area, careType, duration, budget, date, message }) => {
  const lines = [
    "Hi, I found nursinghomeinpenang.com and would like free assistance finding a suitable nursing home in Penang.",
    `My preferred area is ${area || "not specified"}, my care requirements are ${careType || "not specified"}, and my budget is ${budget || "not specified"}.`,
    "Please assist me with the available options.",
  ];
  if (name) lines.push(`Name: ${name}`);
  if (phone) lines.push(`Phone/WhatsApp: ${phone}`);
  if (duration) lines.push(`Preferred duration: ${duration}`);
  if (date) lines.push(`Expected admission date: ${date}`);
  if (message) lines.push(`Message: ${message}`);
  return lines.join("\n");
};

export const buildCaregiverMessage = ({ pkg, name, phone, date, message }) => {
  const lines = [
    "Hi, I found nursinghomeinpenang.com and I'm interested in a caregiver package.",
    pkg
      ? `Package: ${pkg.name}${pkg.hours ? ` (${pkg.hours})` : ""} — ${pkg.caregiver || pkg.note}, ${pkg.days}, ${pkg.price}${pkg.per || "/Month"}.`
      : "Package: not selected yet.",
    "Please share availability and the next steps.",
  ];
  if (name) lines.push(`Name: ${name}`);
  if (phone) lines.push(`Phone/WhatsApp: ${phone}`);
  if (date) lines.push(`Preferred start date: ${date}`);
  if (message) lines.push(`Message: ${message}`);
  return lines.join("\n");
};
